import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

/** List filter for Work Types grid: default shows active and inactive. */
export type WorkTypeActiveFilter = 'all' | 'active' | 'inactive'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[WorkType SetFilter] Action',
  ResetFilter: '[WorkType ResetFilter] Action',
}

const initialWorkTypeState: IWorkTypeState = {
  filter: {
    activeFilter: 'all',
  },
}

export interface IWorkTypeState {
  filter?: {
    activeFilter: WorkTypeActiveFilter
  }
}

export const reducer = persistReducer(
  {storage, key: 'v101-WorkType', whitelist: ['filter']},
  (state: IWorkTypeState = initialWorkTypeState, action: ActionWithPayload<IWorkTypeState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialWorkTypeState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
